import { graphql } from "react-relay";

// gql
import { OnboardingAutopilotEvent } from "@components/onboarding-autopilot-event";

/////////
// GQL //
/////////

export const orgWithOneOnOnesFragment = {
  viewer: graphql`
    fragment OneOnOneAutopilot_viewer on Viewer {
      id
      user {
        id
        orgs(first: 1000000) {
          edges {
            node {
              ...OnboardingAutopilotEvent_org
              id
              experiments
              focusTimeSavedInHours
              primaryOrgEmail
              primaryOrgCalendar
              oneOnOnesForCalendar {
                __typename
                ... on EventList {
                  list {
                    ...OnboardingAutopilotEvent_event
                    moveRangeInLocalTimeV3 {
                      __typename
                      ... on MoveRangeInLocalTimeV3 {
                        allowedStartTimeInclusive {
                          dayOffset
                          timeSlot
                        }
                        allowedEndTimeInclusive {
                          dayOffset
                          timeSlot
                        }
                      }
                      ... on GraphEntityError {
                        message
                      }
                    }
                    eventKey {
                      id
                      calendarIds
                      externalEventId
                      orgId
                    }
                    recurringEventId
                    recurrenceRules {
                      interval {
                        interval
                        freqType
                      }
                    }
                    guestsCanModify
                    title
                    createdMillis
                    isClockwiseEvent
                    organizer {
                      urnValue
                    }
                    startTime {
                      millis
                    }
                    endTime {
                      millis
                    }
                    annotatedEvent {
                      id
                      externalEventId
                      orgTags {
                        tag
                        state {
                          active
                          value
                        }
                      }
                    }
                  }
                }
                ... on GraphEntityError {
                  message
                }
              }
            }
          }
        }
        webAppFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
      }
    }
  `,
};

export const oneOnOnesFragment = {
  org: graphql`
    fragment OneOnOneAutopilot_org on Org {
      ...OnboardingAutopilotEvent_org
      id
      experiments
      focusTimeSavedInHours
      primaryOrgEmail
      primaryOrgCalendar
      oneOnOnesForCalendar {
        __typename
        ... on EventList {
          list {
            ...OnboardingAutopilotEvent_event
            eventKey {
              id
              calendarIds
              externalEventId
              orgId
            }
            recurringEventId
            recurrenceRules {
              interval {
                interval
                freqType
              }
            }
            guestsCanModify
            title
            createdMillis
            isClockwiseEvent
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            annotatedEvent {
              id
              externalEventId
              orgTags {
                tag
                state {
                  active
                  value
                }
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const oneOnOneAutopilotBaseQuery = graphql`
  query OneOnOneAutopilotQuery {
    viewer {
      ...OneOnOneAutopilot_viewer
    }
  }
`;

export const canAutopilotQuery = graphql`
  query OneOnOneAutopilotCanAutopilotQuery(
    $orgRelayId: ID!
    $userCalendarIds: [String!]!
    $externalEventIds: [String!]!
  ) {
    org: node(id: $orgRelayId) {
      ... on Org {
        canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
          __typename
          ... on CanScheduleResponseList {
            list {
              externalEventId
              canAutopilot
            }
          }
        }
      }
    }
  }
`;
